<template>
  <v-card-text class="inserted-values px-9 pt-3">
    <v-row>
      <v-col cols="3" class="request-label">
        Výkon
      </v-col>

      <v-col cols="3" class="request-value">
        {{ individualControlStagesChange.electricPower || missingValueString }} kW
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3" class="request-label">
        Časový posun
      </v-col>

      <v-col cols="3" class="request-value">
        {{ individualControlStagesChange.timeShift || missingValueString }} h
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3" class="request-label">
        Jméno
      </v-col>

      <v-col cols="3" class="request-value">
        {{ individualControlStagesChange.contactName || missingValueString }}
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3" class="request-label">
        Příjmení
      </v-col>

      <v-col cols="3" class="request-value">
        {{ individualControlStagesChange.contactSurname || missingValueString }}
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3" class="request-label">
        Telefon
      </v-col>

      <v-col cols="3" class="request-value">
        {{ individualControlStagesChange.contactPhone || missingValueString }}
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3" class="request-label">
        E-mail
      </v-col>

      <v-col cols="3" class="request-value">
        {{ individualControlStagesChange.contactEmail || missingValueString }}
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
import { formatPhoneNumber } from '@/components/mixins/formatPhoneNumber';

export default {
  name: 'IndividualControlStagesChangeInsertedValues',
  mixins: [formatPhoneNumber],
  props: {
    individualControlStagesChange: {
      type: Object,
      required: false,
    },
  },
};
</script>
